<template>
    <div class="flex items-center gap-2">
        <div class="w-6 h-6 relative checkbox-container">
            <input
                :id="checkboxId"
                ref="checkbox"
                type="checkbox"
                :checked="value"
                @change="emitChange"
                class="w-6 h-6 font-semibold absolute opacity-0"
            >
            <div
                class="flex items-center justify-center rounded-full absolute top-0 left-0 pointer-events-none border border-black/20 checkbox-visual"
                :class="{
                    'rounded-full w-6 h-6': shape === 'circle',
                    'rounded-none w-5 h-5': shape === 'square',
                    'bg-black': value,
                    'bg-white': !value && useCheckForMinus,
                }"
            >
                <transition name="cz3__fade">
                    <template v-if="useCheckForMinus">
                        <img
                            v-if="value"
                            src="../assets/images/icons/check-white.svg"
                            width="16"
                            height="16"
                            class="pointer-events-none absolute"
                        />
                        <img
                            v-else
                            src="../assets/images/icons/minus-icon-white.svg"
                            width="16"
                            height="16"
                            class="pointer-events-none absolute"
                        />
                    </template>
                    <template v-else-if="useXForMinus">
                        <img
                            v-if="value"
                            src="../assets/images/icons/close-white.svg"
                            width="16"
                            height="16"
                            class="pointer-events-none absolute"
                        />
                        <img
                            v-else
                            src="../assets/images/icons/plus-icon-white.svg"
                            width="16"
                            height="16"
                            class="pointer-events-none absolute"
                        />
                    </template>
                    <template v-else>
                        <img
                            v-if="value"
                            src="../assets/images/icons/check-white.svg"
                            width="16"
                            height="16"
                            class="pointer-events-none absolute"
                        />
                        <img
                            v-else
                            src="../assets/images/icons/plus-icon-white.svg"
                            width="16"
                            height="16"
                            class="pointer-events-none absolute"
                        />
                    </template>
                </transition>
            </div>
        </div>

        <label
            :for="checkboxId"
            class="text-sm font-semibold font-oceanside"
        >
            <slot />
        </label>
    </div>
</template>

<style scoped>
    .opacity-0 {
        opacity: 0 !important;
    }

    .checkbox-container:focus-within .checkbox-visual {
        outline: 2px solid #000;
        outline-offset: 2px;
    }
</style>

<script>
    export default {
        props: {
            checkboxId: {
                type: String,
                required: true,
            },

            value: {
                type: Boolean,
                default: false,
            },

            useCheckForMinus: {
                type: Boolean,
                default: false,
            },

            useXForMinus: {
                type: Boolean,
                default: false,
            },

            shape: {
                type: String,
                default: 'circle',
            },
        },

        methods: {
            emitChange() {
                this.$emit('checkboxChecked', this.$refs.checkbox.checked);
            },
        },
    };
</script>
